import './why-us.css';

const WhyHIM = () =>{
    return(
        <div class="why-grid">

            <div class="why-card">
                <h3>✅ Done Right First Time</h3>
                <p>Professional work with attention to detail and full tidy-up after every job.</p>
            </div>

            <div class="why-card">
                <h3>🛡️ Fully Insured & Police-Checked</h3>
                <p>Peace of mind knowing you're fully protected.</p>
            </div>

            <div class="why-card">
                <h3>⚡ Fast Response</h3>
                <p>Availability within one week for many jobs across Melbourne.</p>
            </div>

            <div class="why-card">
                <h3>💰 No Hidden Fees</h3>
                <p>Transparent, upfront fixed quotes with no surprises.</p>
            </div>

            <div class="why-card">
                <h3>📍 Melbourne-Wide</h3>
                <p>We cover most suburbs for homes and small commercial jobs.</p>
            </div>

            <div class="why-card">
                <h3>🤝 Customer-Focused</h3>
                <p>Friendly service and clear communication from quote to completion.</p>
            </div>

      </div>
    )
}

export default WhyHIM;